import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import Tooltip from "@mui/material/Tooltip";
import { HXTooltipContentContainer } from "./HXTooltipWrapperView.styles";
export const HXTooltipWrapperView = observer((props) => {
    const { tooltip, show, showOnlyWhenTruncated, children, placement, arrow, stretch, align, addTouchControls, offset, maxWidth, color, backgroundColor, boxShadow, padding, removeMousePointer, } = props;
    const [isTruncated, setIsTruncated] = React.useState(false);
    const contentRef = React.useRef(null);
    React.useEffect(() => {
        if (!showOnlyWhenTruncated || !contentRef.current)
            return undefined;
        const child = contentRef.current.firstElementChild;
        const target = child instanceof HTMLElement ? child : contentRef.current;
        const check = () => {
            setIsTruncated(target.scrollWidth > target.clientWidth || target.scrollHeight > target.clientHeight);
        };
        check();
        const resizeObserver = new ResizeObserver(check);
        resizeObserver.observe(target);
        return () => {
            resizeObserver.disconnect();
        };
    }, [showOnlyWhenTruncated, tooltip]);
    const sx = {};
    const arrowSx = {};
    if (maxWidth !== undefined)
        sx.maxWidth = maxWidth;
    if (color)
        sx.color = color;
    if (backgroundColor) {
        sx.backgroundColor = backgroundColor;
        arrowSx.color = backgroundColor;
    }
    if (boxShadow)
        sx.boxShadow = boxShadow;
    if (padding)
        sx.padding = padding;
    const resolvedTooltip = showOnlyWhenTruncated && !isTruncated ? undefined : tooltip;
    return (_jsx(Tooltip, { title: show !== false ? resolvedTooltip : null, placement: placement, arrow: arrow, componentsProps: {
            tooltip: {
                sx,
            },
            arrow: {
                sx: arrowSx,
            },
        }, PopperProps: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: offset !== null && offset !== void 0 ? offset : [0, 0],
                    },
                },
            ],
        }, ...(addTouchControls ? { enterTouchDelay: 0, leaveTouchDelay: 15000 } : {}), children: _jsx(HXTooltipContentContainer, { ref: contentRef, stretch: stretch, align: align, removeMousePointer: removeMousePointer || (showOnlyWhenTruncated && !isTruncated), children: children }) }));
});
